
import { useAuth } from "./AuthContext";
import { useTheme } from "./ThemeContext";

// Custom hook to clear the state of BusinessContext
export const useClearState = () => {
  const { dispatch: authDispatch} = useAuth();
  const { dispatch: themeDispatch} = useTheme();
  
  // Function to clear the state
  const clearAllState = () => {
    authDispatch({ type: 'CLEAR'});
    themeDispatch({ type: 'CLEAR'});
  }

  return clearAllState;
};
